import { LIVE_STATUS_LABEL, type LiveStatus } from '@pidelo/web-core';
import { cx } from '../../internal/cx.ts';
import styles from './LiveIndicator.module.css';

export type LiveIndicatorProps = {
  status: LiveStatus;
  /** On the dark menu or on a light page. */
  surface?: 'light' | 'dark';
  /** Only the dot (the text stays for screen readers). */
  compact?: boolean;
  label?: string;
  className?: string;
};

/** «En vivo» / «Reconectando…»: whether the screen is getting changes as they happen. */
export function LiveIndicator({ status, surface = 'light', compact, label, className }: LiveIndicatorProps) {
  const text = label ?? LIVE_STATUS_LABEL[status];
  return (
    <span className={cx(styles.live, styles[surface], compact && styles.compact, className)} data-status={status} role="status" title={compact ? text : undefined}>
      <i className={styles.dot} aria-hidden="true" />
      <span className={compact ? styles.hidden : undefined}>{text}</span>
    </span>
  );
}
